// stores/queryStore.ts
import { defineStore } from 'pinia';

export const useQueryStore = defineStore('queryStore', {
  actions: {
    bulkSetQuery(newQuery: Record<string, any>) {
      this.query = {
        ...this.query,
        ...Object.fromEntries(Object.entries(newQuery).filter(([_, v]) => v !== undefined && v !== null && v !== '')),
      };
    },
    clearQuery() {
      this.query = {};
    },
    removeQueryKey(key: string) {
      delete this.query[key];
    },
    setQuery(key: string, value: string | null | undefined) {
      if (value === undefined || value === null || value === '') {
        delete this.query[key];
      } else {
        this.query[key] = value;
      }
    },
  },
  state: () => ({
    query: {} as Record<string, string>,
  }),
});
